var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overallStatisticsRootBox" },
    [
      _vm.userType === _vm.admin
        ? _c("admin-layout", {
            staticStyle: { "padding-right": "16px", "box-sizing": "border-box" }
          })
        : _vm.userType === _vm.teacher
        ? _c("teacher-layout")
        : _vm.userType === _vm.student
        ? _c("student-layout")
        : _c("div", { staticClass: "m-empty" }, [
            _vm._v("未知人员类型（请刷新或者重新登陆）")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25ba314f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25ba314f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/overallStatistics.vue
// module id = null
// module chunks = 